export interface PrintOption {
  canvasId?: string;
  content?: string;
  top?: number;
  left?: number;
  width?: number;
  height?: number;
  title?: string;
  styles?: string | string[];
  stylesTags?: string | string[];
}

const print = (options?: PrintOption) => {

  if (!options) options = {};

  options.width = options.width ?? Math.ceil(window.screen.width / 2);
  options.height = options.height ?? Math.ceil(window.screen.height / 2);
  options.left = options.left ?? options.width - Math.floor(options.width / 2);
  options.top = options.top ?? options.height - Math.floor(options.height / 2);

  if (!options.styles) {
    options.styles = [];
  }
  else if (typeof options.styles === 'string') {
    options.styles = [options.styles];
  }

  if (!options.stylesTags) {
    options.stylesTags = [];
  }
  else if (typeof options.stylesTags === 'string') {
    options.stylesTags = [options.stylesTags];
  }

  const win = window.open('', 'Print', `
    scrollbars=yes,
    height=${options.height},
    width=${options.width},
    left=${options.left},
    top=${options.top}
  `);

  const styles = options.styles.map(s => `<link rel="stylesheet" type="text/css" href="${s}" />`).join('');
  const stylesTags = options.stylesTags.map(s => `<style>${s}</style>`).join('');
  win.document.write(`<html><head><title>${options.title ?? ''}</title>${styles}${stylesTags}</head><body>`);
  if (options.canvasId) {
    const canvas = document.getElementById(options.canvasId) as HTMLCanvasElement;
    if (!canvas) {
      throw new Error(`Element not found with id ${options.canvasId}`);
    }
    const dataUrl = canvas.toDataURL();
    win.document.write(`
    <br>
    <img src="${dataUrl}" style="width: 100%">
    <br>
  `);
  }
  if (options.content) {
    win.document.write(options.content);
  }
  win.document.write(
    `<div style="text-align: center; display: flex;align-items: center; flex-direction: column;">
      <img src="/logo.png" style="width: 50px; height: auto;">
      <span style="margin-top: 1rem">سامانه پایش دارستان صنعت</span>
    </div>
  `);
  win.document.write('</body></html>');
  win.document.close();

  win.onload = () => {
    win.focus();
    win.print();
  }

}

export default print;
